import { UsAccountClient } from './accountClient';
import { sendUsBrowserRequest, usBrowserSession } from './browserTradingClient';

export function createUsBrowserAccountClient(): UsAccountClient {
  return new UsAccountClient({ session: usBrowserSession, send: sendUsBrowserRequest });
}
